import { render, staticRenderFns } from "./HiboCurrencyInput.vue?vue&type=template&id=4c406cd4&"
import script from "./HiboCurrencyInput.vue?vue&type=script&lang=ts&"
export * from "./HiboCurrencyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports